<div class="txt-words">
  <h2 cdkFocusInitial class="txt-primary"> {{ data.duration }} <i class="far fa-times-circle" (click)="closeDialog()"></i> </h2>
  <h3 class="py-2 txt-primary" style="text-align: justify;"> {{ data.title }} </h3>
  <div style="max-height: 45vh; overflow-y: auto;">
    <h4 style="text-align: justify;">
      {{ data.description }}
    </h4>
  </div>
  <div *ngIf="data.link" class="pt-4 pb-2">
    <span style="font-weight: 450;">
      {{data.link.name}} :
    </span>
    <a [href]="data.link.value"> {{ data.link.displayName }} </a>
  </div>
  <div class="text-right py-2">
    <button mat-button class="bk-primary-orange" (click)="closeDialog()">Close</button>
  </div>
</div>